import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from '../../../../core/models/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SendToBankTransactionFlowSession } from '../../../../core/service/SendToBankTransactionFlowSession';
import { SendMoneyTransactionFlowSession } from '../../../../core/service/sendMoneyTransactionFlowSession';
import { ReceiveMoneyTransactionFlowSession } from '../../../../core/service/ReceiveMoneyTransactionFlowSession';
import { UserService } from '../../../../core/service/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SanitizerService } from '../../../../core/security/sanitizer.service';
import { FormsModule } from '@angular/forms';

export interface ConfirmDialogData {
  transactionFlow: any;
  icon:any;
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  showCloseIcon?: boolean;
   firstSentence?: string;
showDuplicateCards?: boolean;
 showNoteField?: boolean;
  noteLabel?: string;
    isErrorStyle?: boolean;
duplicateCustomers?: {
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  nationality: string;
  name: string;            // Document type (Passport)
  documentNumber: string;
  expiryDate: string;
  countryName: string;
}[];

 file?: string | null;
  fileType?: 'image' | 'pdf' | null;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule,MaterialModule,TranslateModule, FormsModule], 
  template: `
  <div class="dialog">
   <div>
    <h2 mat-dialog-title>
    <mat-icon [ngClass]="{'error-text': data.isErrorStyle}">{{ data.icon }}</mat-icon>  
    {{ data.title }}</h2>

     <!--  Close icon (ONLY when enabled) -->
    <button
      *ngIf="data?.showCloseIcon"
      mat-icon-button
      class="close-btn dialog-close-btn"
      aria-label="Close dialog"
      (click)="onClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

    <mat-dialog-content>
     <!-- First sentence in RED -->
  <p *ngIf="data.firstSentence"  
  style="color: #d32f2f !important; font-weight: 600;"
   class="first-sentence">
    {{ data.firstSentence }}
  </p>

      <p [ngClass]="{'error-text': data.isErrorStyle}">{{ data.message  }}</p>

      <!-- IMAGE PREVIEW -->
      <img
        *ngIf="data.file && (data.fileType === 'image' || getFileType(data.file) === 'image')"
        [src]="data.file"
        [class.popup-image]="!isImageExpanded"
        [class.expanded-image]="isImageExpanded"
        (click)="toggleImageExpansion()"
        alt="Preview" 
        style="cursor: pointer;"
      />

      <!-- PDF PREVIEW (Small) -->
      <div 
        *ngIf="data.file && (data.fileType === 'pdf' || getFileType(data.file) === 'pdf') && safePdfUrl && !isPdfExpanded"
        class="pdf-preview-wrapper"
        (click)="togglePdfExpansion()"
      >
        <iframe
          [src]="safePdfUrl"
          class="popup-pdf"
        ></iframe>
        <div class="click-to-expand">Click to expand</div>
      </div>

      <!-- PDF Overlay with Close Button and Expanded PDF -->
      <div *ngIf="isPdfExpanded" class="pdf-overlay" (click)="togglePdfExpansion()">
        <button class="overlay-close-btn" (click)="togglePdfExpansion(); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
        <iframe
          [src]="safePdfUrl"
          class="expanded-pdf"
          (click)="$event.stopPropagation()"
        ></iframe>
      </div>

      <!-- Image Overlay with Close Button -->
      <div *ngIf="isImageExpanded" class="image-overlay" (click)="toggleImageExpansion()">
        <button class="overlay-close-btn" (click)="toggleImageExpansion(); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

<!-- NOTE FIELD (Optional) -->
<div *ngIf="data?.showNoteField" class="note-field">
  <div class="note-row">
    <label class="note-label">{{'NOTE'|translate}}*</label>

    <div class="note-input-wrapper">  
    <mat-form-field appearance="outline" class="note-input">
      <textarea
        matInput
        [(ngModel)]="noteValue"
        #noteCtrl="ngModel"
        required
        rows="2"
          (keyup)="checkLatinnNote($event)"
        maxlength="500">
      </textarea>

      <mat-error *ngIf="noteCtrl.invalid && noteSubmitted && !greekErrorNote">
        Note is required
      </mat-error>
    </mat-form-field>
      <div *ngIf="greekErrorNote" class="greek-error-msg">
   {{ 'Note ' + ('ADDITIONAL_INFORMATION.LATIN_VALIDATION' | translate) }}      </div>
    </div>

  </div>
</div>


    </mat-dialog-content>

 <!-- DUPLICATE CUSTOMER LIST -->
<div  *ngIf="data?.showDuplicateCards && data?.duplicateCustomers?.length"  class="duplicate-cards-container">

  <div
    class="customer-result-card"
    *ngFor="let c of data.duplicateCustomers"
    (click)="goToCustomerDetails(c.id)"
    [class.selected]="selectedCustomer?.id === c.id"
  >
    <div class="customer-header">
      {{ c.firstName | titlecase }} {{ c.lastName | titlecase }}
    </div>

    <div class="customer-row">
      <span>Date of Birth:</span>
      <strong>{{ c.dateOfBirth | date:'dd/MM/yyyy' }}</strong>
    </div>

    <div class="customer-row">
      <span>Nationality:</span>
      <strong>{{ c.nationality }}</strong>
    </div>

    <div class="customer-row">
      <span>Document:</span>
      <strong>{{ c.name }}</strong>
    </div>

    <div class="customer-row">
      <span>Document No:</span>
      <strong>{{ c.documentNumber }}</strong>
    </div>

    <div class="customer-row">
      <span>Expiry Date:</span>
      <strong>{{ c.expiryDate | date:'dd/MM/yyyy' }}</strong>
    </div>

    <div class="customer-row">
      <span>Country:</span>
      <strong>{{ c.countryName }}</strong>
    </div>

  </div>

</div>


    <mat-dialog-actions align="end">
      <button mat-raised-button  mat-button  (click)="onCancel()" class="back_btn"  *ngIf="data.cancelText">{{ data.cancelText || 'CANCEL'|translate }}</button>
      <button mat-raised-button  mat-button  (click)="onConfirm()" class="next_btn"  *ngIf="data.confirmText" >{{ data.confirmText || 'OK'|translate }}</button>


    </mat-dialog-actions>
    </div>
  `,
  styles: [`
    mat-dialog-actions {
      display: flex;
      justify-content:center !important;
    }
.note-field {
  margin-top: 15px;
}
.note-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.note-input-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.greek-error-msg {
  color: #f44336;
  font-size: 12px;
  margin-top: -16px;
  padding-left: 16px;
  font-family: var(--main-font);
}
.note-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.note-label {
  min-width: 60px;
  font-weight: 600;
  margin-top: 12px;
 font-family: var(--main-font);
font-size: 15px !important;
color: var(--primary-color) !important;
}

.note-input {
  flex: 1;
}

.full-width {
  width: 100%;
}

    ::ng-deep .mdc-dialog__title{
  text-align: center !important;
  font-family: var(--main-font) !important;
  color:var(--primary-color)!important;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top:10px;
  font-weight: 600 !important;
}
.mat-mdc-dialog-title::before{
  display:none;
}
.mat-icon{
  padding-bottom: 7px;
    color:var(--primary-color);
    width: 25px;
    height: auto;
    font-size: 25px;
}
.mat-icon.error-text{
 color:#f33030 !important;
}
.next_btn,.back_btn{
  width:160px !important;
}
.mat-mdc-dialog-content p{
    text-align: center !important;
    font-family: var(--main-font);
    font-size:15px !important;
    color: var(--primary-color);
}
::ng-deep .mat-mdc-dialog-content p.error-text {
  color: red !important;
}
    .dialog-header {
  position: relative;
  display: flex;
  justify-content: center;
}

.close-btn {
  position: absolute;
  top: 0;
  right: 5px;
  color: var(--primary-color);
}
 /* Container: controls scrolling */
.duplicate-cards-container {
  display: flex;
  flex-wrap: nowrap;             
  gap: 12px;
  overflow-x: auto;            
  overflow-y: hidden;
  padding: 10px 0;
  max-width: 100%;
}

/* Hide ugly scrollbar (optional) */
.duplicate-cards-container::-webkit-scrollbar {
  height: 6px;
}
.duplicate-cards-container::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 10px;
}

/* Each card */
.customer-result-card {
  flex: 0 0 calc(33.33% - 12px); 
  max-width: calc(33.33% - 12px);
  min-width: 200px;              
  border: 1px solid var(--primary-color);
  border-radius: 10px;
  overflow: hidden;
}

.dialog{
  padding:0px 8px !important;
}
// .customer-result-card {
//   // flex: 1 1 300px;      
//   // max-width: 320px;   
//       flex: 1 1 50px;
//     max-width: 200px;
//     border: 1px solid var(--primary-color);
//     border-radius: 10px;
//     overflow: hidden;
//     margin: 10px auto;
//     // width: 400px;
// }
.customer-header {
  background:var(--primary-color);
  color: #fff;
  font-weight: 600;
  padding: 10px;
  text-align: center;
}

.customer-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 6px;
  font-size: 13px;
}

.customer-row:last-child {
  border-bottom: none;
}
@media(max-width:768px){
 ::ng-deep .mat-mdc-dialog-inner-container {
       overflow: auto !important;
    max-height: 800px !important;
}
.customer-result-card {
  flex: 1 1 300px;      
  max-width: 320px;  
}
}

/* STRICTLY inside THIS dialog component */
:host ::ng-deep .dialog-close-btn.mat-mdc-icon-button
  .mat-mdc-button-ripple,
:host ::ng-deep .dialog-close-btn.mat-mdc-icon-button
  .mat-mdc-button-persistent-ripple,
:host ::ng-deep .dialog-close-btn.mat-mdc-icon-button
  .mat-mdc-button-persistent-ripple::before {
       margin-right: 5px !important;
    margin-left: 3px !important;
    width: 30px !important;
    height: 30px !important;
    margin-top: 3px !important;
}
 .popup-image {
  width: 100%;
  max-height: 55vh; 
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: none;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.expanded-image {
  // position: fixed;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // width: 90%;
  // height: auto;
  // z-index: 10001;
  // border-radius: 8px;
  // box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  // object-fit: contain;
  // cursor: zoom-out;
  // background: white;
    position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  z-index: 10001;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  cursor: zoom-out;
  background: transparent;
}

.popup-pdf {
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 8px;
  margin: 20px 0;
  pointer-events: none;
}

.pdf-preview-wrapper {
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pdf-preview-wrapper:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  transform: scale(1.01);
}

.click-to-expand {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.pdf-preview-wrapper:hover .click-to-expand {
  opacity: 1;
}

.expanded-pdf {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  z-index: 10001;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  background: white;
  border: none;
  pointer-events: auto;
}

/* Overlay for PDF and Image */
.pdf-overlay,
.image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  cursor: zoom-out;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Close button on overlay */
.overlay-close-btn {
  position: fixed;
  top: 20px;
  right: 30px;
  z-index: 10002;
  background: white;
  border: none;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  transition: all 0.3s ease;
}

.overlay-close-btn:hover {
  background: #f5f5f5;
  transform: scale(1.1);
}

.overlay-close-btn mat-icon {
  color: #333;
  font-size: 28px;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
}


  `]
})
export class ConfirmDialogComponent implements OnInit {
  safePdfUrl?: SafeResourceUrl;
  
  constructor(
     public dialogRef: MatDialogRef<ConfirmDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  private router: Router,
  private userservice: UserService,
  private sanitizer: SanitizerService
  ) {
  }
noteValue: string = '';
noteSubmitted: boolean = false;

  selectedCustomer: any = null;
  isImageExpanded = false;
  isPdfExpanded = false;

  ngOnInit() {
    // Sanitize PDF URL if needed
    if (this.data.file && (this.data.fileType === 'pdf' || this.getFileType(this.data.file) === 'pdf')) {
      const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(this.data.file)}&embedded=true`;
      this.safePdfUrl = this.sanitizer.sanitizeResourceUrl(viewerUrl);
    }
  }

goToCustomerDetails(customerId: string): void {
  if (!customerId) return;

  this.dialogRef.close();

  const id = customerId.toUpperCase();

  this.userservice.getCustomerid(id).subscribe({
    next: (customer: any) => {    

      if (this.data.transactionFlow === 'SEND_TO_BANK') {
        SendToBankTransactionFlowSession.saveStep('step3', { customerId: id });
        SendToBankTransactionFlowSession.saveStep('step4', { customerDetails: customer });

        this.router.navigate([
          '/agent/send-to-bank/send-to-bank-customer-Details',
          id
        ]);
      }

      else if (this.data.transactionFlow === 'SEND_MONEY') {
        SendMoneyTransactionFlowSession.saveStep('step3', { customerId: id });
        SendMoneyTransactionFlowSession.saveStep('step4', { customerDetails: customer });

        this.router.navigate([
          '/agent/send-money/send_money_customer_details',
          id
        ]);
      }

      else if (this.data.transactionFlow === 'RECEIVE_MONEY') {
        ReceiveMoneyTransactionFlowSession.saveStep('step3', { customerId: id });
        ReceiveMoneyTransactionFlowSession.saveStep('step4', { customerDetails: customer });

        this.router.navigate([
          '/agent/receive-money/receive_money_customer_details',
          id
        ]);
      }
    },
    error: (err: any) => {       
    }
  });
}

  toggleImageExpansion(): void {
    this.isImageExpanded = !this.isImageExpanded;
    
    if (this.isImageExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      setTimeout(() => {
        document.body.style.overflow = '';
      }, 300);
    }
  }

  togglePdfExpansion(): void {
    this.isPdfExpanded = !this.isPdfExpanded;
    
    if (this.isPdfExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      setTimeout(() => {
        document.body.style.overflow = '';
      }, 300);
    }
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  // onConfirm(): void {
  //   this.dialogRef.close(true);
  // }

  onConfirm() {
   if (this.data.showNoteField) {

    this.noteSubmitted = true;

    if (!this.noteValue || !this.noteValue.trim()) {
      return; // stop closing dialog
    }
  }
   if(this.noteValue!=''){
     this.dialogRef.close({
    confirmed: true,
    note: this.noteValue || ''});
   }else{
     this.dialogRef.close(true);
   }
 
}


  onCancel(): void {
    this.dialogRef.close(false);
  }
  onClose(): void {
  this.dialogRef.close();
}


  getFileType(fileName: string | undefined): 'image' | 'pdf' | null {
    if (!fileName) return null;
    
    const ext = fileName.toLowerCase().split('.').pop();
    
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext || '')) {
      return 'image';
    }
    if (ext === 'pdf') {
      return 'pdf';
    }
    return null;
  }
  greekErrorNote: boolean = false;
checkLatinnNote(event: any) {
  const value = this.noteValue;
  
  if (!value || value.trim() === '') {
    this.greekErrorNote = false; // No error when empty
    return;
  }

  const greekRegex = /[\u0370-\u03FF]/; 
  this.greekErrorNote = greekRegex.test(value);
  }
}